var map = {
	"./circle_dna_w.svg": "2f2a",
	"./dark/ff01.svg": "2502",
	"./dark/ff02.svg": "d2ee",
	"./dark/ff03.svg": "334d",
	"./dark/ff03_alt.svg": "5b01",
	"./dna.svg": "7053",
	"./dna_s.svg": "0ab6",
	"./dna_w.svg": "3fb3",
	"./ff01.svg": "f121",
	"./ff01d.svg": "ded5",
	"./ff02.svg": "47cd",
	"./ff02d.svg": "1472",
	"./ff03.svg": "90ac",
	"./ff03_alt.svg": "a58e",
	"./ff03d.svg": "9e5b",
	"./ff03d_alt.svg": "f6d7",
	"./logistik.svg": "2693",
	"./logistik_s.svg": "79d7",
	"./logistik_w.svg": "a3e4",
	"./optik.svg": "5093",
	"./optik_s.svg": "cf5b",
	"./optik_w.svg": "198a",
	"./prod-mat.svg": "d7fa",
	"./prod-mat_s.svg": "967a",
	"./prod-mat_w.svg": "3d9a",
	"./recht-mang.svg": "9ca1",
	"./recht-mang_s.svg": "1025",
	"./recht-mang_w.svg": "c9b1",
	"./standard.svg": "5667",
	"./telematik.svg": "2d18",
	"./telematik_s.svg": "7f27",
	"./telematik_w.svg": "dfe8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49fb";